import { Box, Grid, Typography } from '@arquivei/atenas';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import React from 'react';

import { faqData } from './faqData';

export default function Faq(): React.ReactElement {
  return (
    <Box data-testid="faq-section">
      <Grid container>
        <Grid md={6} xs={12} sx={{ pt: { xs: 3, md: 9 } }}>
          <Typography level="display1" gutterBottom>
            {faqData.title}
          </Typography>
        </Grid>
      </Grid>

      <Grid container mt={4}>
        {faqData.features.map((item) => {
          return (
            <Accordion
              key={item.title}
              sx={{
                minWidth: '100%',
                mb: 1,
                boxShadow: 'none',
                '::before': {
                  background: 'none',
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                data-testid="faq-summary"
              >
                <Typography level="h4">{item.title}</Typography>
              </AccordionSummary>
              <AccordionDetails id="faq-details">
                <Typography textColor="text.secondary">
                  {item.description}
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Grid>
    </Box>
  );
}
